import { BaseGetRequest } from './core/baseGetRequest';
import { FileUrl, FileUrlDynamicType } from '../models/fileUrl';
import { Authentication } from './core/baseRequest';

export class QuotePdfUrlRequest extends BaseGetRequest<FileUrl> {
    constructor(public id: string) {
        super(`quotes/${id}/pdf`, {}, FileUrlDynamicType, Authentication.SharingToken);
    }
}
